/**
 * DevExtreme (viz/components/consts.js)
 * Version: 16.2.5
 * Build date: Mon Feb 27 2017
 *
 * Copyright (c) 2012 - 2017 Developer Express Inc. ALL RIGHTS RESERVED
 * EULA: https://www.devexpress.com/Support/EULAs/DevExtreme.xml
 */
"use strict";
module.exports = {
    events: {
        mouseover: "mouseover",
        mouseout: "mouseout",
        mousemove: "mousemove",
        touchstart: "touchstart",
        touchmove: "touchmove",
        touchend: "touchend",
        mousedown: "mousedown",
        mouseup: "mouseup",
        click: "click",
        selectSeries: "selectseries",
        deselectSeries: "deselectseries",
        selectPoint: "selectpoint",
        deselectPoint: "deselectpoint",
        showPointTooltip: "showpointtooltip",
        hidePointTooltip: "hidepointtooltip"
    },
    states: {
        hover: "hover",
        normal: "normal",
        selection: "selection",
        normalMark: 0,
        hoverMark: 1,
        selectedMark: 2,
        applyHover: "applyHover",
        applySelected: "applySelected",
        resetItem: "resetItem"
    },
    pieLabelIndent: 30,
    pieLabelSpacing: 10,
    pieSeriesSpacing: 4
};



//////////////////
// WEBPACK FOOTER
// /home/backend/NasheDelo/WebLombard/client/~/devextreme/viz/components/consts.js
// module id = ../../../../devextreme/viz/components/consts.js
// module chunks = 3